import React, { Component } from 'react';

const contactStyle = {
    marginBottom: "30px",
  };

export default class ContactoSmall extends Component {

    detectPhone = () => {

        if(this.props.contacto.phoneNumber.startsWith('9')){
            return('Telemóvel')
        } else{
            return('Telefone')
        }

    }

    render() {
        return (
            <div className="col-6 col-md-3">
              <div style={contactStyle} className="contact-small">
                <p className="contact contact-main contact-name">{this.props.contacto.name}</p>
                
                <p className="contact contact-grey contact-title">{this.detectPhone()}</p>
                <p className="contact contact-main contact-data">{this.props.contacto.phoneNumber}</p>

        <p className="contact contact-grey contact-title">{this.props.contacto.email !== '' && 'Email' }</p>
                <p className="contact contact-main contact-data">{this.props.contacto.email !== '' ? this.props.contacto.email : ' '}</p>
              </div>
            </div>
        )
    }
}
